"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var events_1 = require("events");
var Server = /** @class */ (function (_super) {
    tslib_1.__extends(Server, _super);
    /**
     * @description
     * Emulates node js http server in the browser.
     * See: https://nodejs.org/api/http.html#http_class_http_server
     *
     * @param onRequest An optional function called on each request.
     */
    function Server(onRequest) {
        var _this = _super.call(this) || this;
        _this.listening = false;
        if (onRequest) {
            _this.on("request", onRequest);
        }
        return _this;
    }
    /**
     * @description
     * Starts a server and sets listening to true.
     * Adapters will hook into this to startup routers on individual platforms.
     *
     * @param onListening An optional function called once the server has started.
     */
    Server.prototype.listen = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Automatically add callback `listen` handler.
        var onListening = args[args.length - 1];
        if (typeof onListening === "function") {
            this.once("listening", onListening);
        }
        // Ensure that listening is `async`.
        setTimeout(function () {
            // Mark server as listening.
            _this.listening = true;
            _this.emit("listening");
        }, 0);
        return this;
    };
    /**
     * @description
     * Closes the server and destroys all event listeners.
     *
     * @param onClode An option function called once the server stops.
     */
    Server.prototype.close = function (onClose) {
        var _this = this;
        // Automatically add callback `close` handler.
        if (typeof onClose === "function") {
            this.once("close", onClose);
        }
        // Ensure that closing is `async`.
        setTimeout(function () {
            // Mark server as closed.
            _this.listening = false;
            _this.emit("close");
        }, 0);
        return this;
    };
    /**
     * @description
     * This is a noop in the browser.
     */
    Server.prototype.unref = function () {
        return this;
    };
    /**
     * @description
     * This is a noop in the browser.
     */
    // tslint:disable-next-line
    Server.prototype.address = function () { };
    return Server;
}(events_1.EventEmitter));
exports.Server = Server;
//# sourceMappingURL=server.js.map